module.exports = __webpack_public_path__ + "static/media/play-button.09f74475.svg";